import { StationTab } from '../../../lib/StationTab';
import { DeviceCard } from './components';
import S from './Firmware.module.scss';
import { useFirmware } from './useFirmware';

export const Firmware: StationTab = ({ station }) => {
    const { modal, firmware, showEditLicenseKeyModal } = useFirmware(station);

    if (!firmware) {
        return null;
    }

    const sortedFirmware = firmware.devices.sort((a, b) => a.type.id - b.type.id);

    return (
        <div className={S.StationFirmware}>
            {sortedFirmware.map((device) => (
                <DeviceCard key={device.id} device={device} onClickEditLicenseKey={showEditLicenseKeyModal} />
            ))}

            {modal}
        </div>
    );
};
